import React from 'react';
import Image from '@atlaskit/image';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import src from './JiraLogo.svg';

export const JiraLogoPlaceholder = () => {
	return (
		<>
			<Image src={src} alt="Loading Jira..." />
			<UFOLoadHold name="jira-spa" />
		</>
	);
};
